import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const validateStaffsDocuments = (fileId: number) => {
  return restApiClient.url(constructApiUrl(API.staffs.validate.url, { id: fileId })).post()
}
